import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingLoadsReconcileAtom = createMutationAtomFactory(
  'trade.bookingLoadsReconcile',
  (params: { bookingId: string }) => ({
    tradeBookingLoadsReconcile: {
      __args: {
        bookingId: params.bookingId,
      },
      id: true,
      status: true,
    },
  }),
);
